// @flow

import _ from 'lodash';

import { createToolbarEvent, sendAnalytics } from '../../analytics';
import { appNavigate } from '../../app/actions';
import { disconnect } from '../../base/connection';
import { openDialog } from '../../base/dialog';
import { translate } from '../../base/i18n';
import { JitsiRecordingConstants } from '../../base/lib-jitsi-meet';
import { connect } from '../../base/redux';
import { AbstractHangupButton } from '../../base/toolbox/components';
import type { AbstractButtonProps } from '../../base/toolbox/components';
import LocalRecordingManager from '../../recording/components/Recording/LocalRecordingManager.web';
import { StopRecordingDialog } from '../../recording/components/Recording/web/index';
import { getActiveSession, getRecordButtonProps } from '../../recording/functions';
import { participantsLeftMetting } from '../actions.any';

/**
 * The type of the React {@code Component} props of {@link HangupButton}.
 */
type Props = AbstractButtonProps & {

    /**
     * The redux {@code dispatch} function.
     */
    dispatch: Function,

    /**
     * True if there is a running active recording, false otherwise.
     */
     _isRecordingRunning: boolean,

};

/**
 * Component that renders a toolbar button for leaving the current conference.
 *
 * @augments AbstractHangupButton
 */
class HangupButton extends AbstractHangupButton<Props, *> {
    _hangup: Function;

    accessibilityLabel = 'toolbar.accessibilityLabel.hangup';
    label = 'toolbar.hangup';
    tooltip = 'toolbar.hangup';

    /**
     * Initializes a new HangupButton instance.
     *
     * @param {Props} props - The read-only properties with which the new
     * instance is to be initialized.
     */
    constructor(props: Props) {
        super(props);

        this._hangup = () => {
            this.props.dispatch(participantsLeftMetting());
            if (this.props._isRecordingRunning) {
                this.props.dispatch(openDialog(StopRecordingDialog));
            }

            if (this.props._isRecordingRunning === false) {
                this.props.dispatch(participantsLeftMetting());
                sendAnalytics(createToolbarEvent('hangup'));

                // FIXME: these should be unified.
                if (navigator.product === 'ReactNative') {
                    this.props.dispatch(appNavigate(undefined));
                } else {
                    this.props.dispatch(disconnect(true));
                }
            }
        };
    }

    /**
     * Helper function to perform the actual hangup action.
     *
     * @override
     * @protected
     * @returns {void}
     */
    _doHangup() {
        this._hangup();
    }
}

/**
 * Maps (parts of) the redux state to the associated props for the
 * {@code RecordButton} component.
 *
 * @param {Object} state - The Redux state.
 * @private
 * @returns {{
 *     _isRecordingRunning: boolean,
 * }}
 */
export function _mapStateToProps(state: Object): Object {

    return {
        _isRecordingRunning: Boolean(getActiveSession(state, JitsiRecordingConstants.mode.FILE))
            || LocalRecordingManager.isRecordingLocally()
    };
}


export default translate(connect(_mapStateToProps)(HangupButton));
